var map = {
	"./OLD/alerts.svg": "1d44",
	"./OLD/bell.svg": "6725",
	"./OLD/chat-46.svg": "4437",
	"./OLD/compare.svg": "0bc2",
	"./OLD/dashboard.svg": "4015",
	"./OLD/exclusive.svg": "109e",
	"./OLD/export.svg": "6b0a",
	"./OLD/eye-19.svg": "d46f",
	"./OLD/favorite.svg": "42ce",
	"./OLD/grid-45.svg": "6c7f",
	"./OLD/import.svg": "945e",
	"./OLD/layers-3.svg": "7c19",
	"./OLD/notes.svg": "4b2e",
	"./OLD/preferences.svg": "20ff",
	"./OLD/price-comparison.svg": "b21e",
	"./OLD/single-folded-content.svg": "2475",
	"./OLD/square-download.svg": "8faf",
	"./alert.svg": "8a73",
	"./compare.svg": "fa26",
	"./compare2.svg": "1fe2",
	"./dashboard.svg": "e637",
	"./exclusive.svg": "021e",
	"./export.svg": "0bbf",
	"./favorite.svg": "6508",
	"./import.svg": "23a0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32fc";